var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-form',{ref:"editForm",attrs:{"user":_vm.user,"validations":_vm.validations,"title":_vm.$t('label.editUser')},on:{"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }